<template>
  <daiban-tool :flow="flow"> </daiban-tool>
</template>
<script>
import daibanTool from "./daibanTool.vue";
export default {
  components: { daibanTool },
  data() {
    return {
      flow: {
          id: "1637655498083803137",
          name: "巡查管理",
          name1: "巡查待办处理",
        },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/daibanxuncha.vue